'use strict';

var _ = require('lodash');
var FaresOptimizerWarningModalDirective = function FaresOptimizerWarningModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-optimizer-warning-modal.html'),
    controller: 'FaresOptimizerWarningModalController',
    scope: {
      warningCallback: '=',
      showWarningModal: '=',
      warningModalData: '='
    },
    link: function link($scope, $element) {
      $scope.$watch('showWarningModal', function (newVal) {
        if (newVal) {
          $scope.ruleMissingWarningMsg = $scope.warningModalData.ruleMissingWarningMsg;
          $scope.cancelLadderWarningMsg = $scope.warningModalData.cancelLadderWarningMsg;
          $element.modal('show');
          $scope.showWarningModal = false;
        }
      });
    }
  };
};
FaresOptimizerWarningModalDirective.$inject = [];
module.exports = FaresOptimizerWarningModalDirective;